import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gift",
  "use": "icon-gift-usage",
  "viewBox": "0 0 21 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 23\" id=\"icon-gift\"><g stroke=\"#000\" stroke-width=\"1.25\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.464 22.74h18.301v-9.608H1.464zM.625 13.13h19.979V7.168H.625z\" /><path d=\"M10.614 7.169S10.276.625 5.978.625s-4.732 6.544 0 6.544M15.25 7.169c4.732 0 4.298-6.544 0-6.544-4.297 0-4.636 6.544-4.636 6.544M10.614 7.169v15.572\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol